import React, { useState, useEffect, useRef } from 'react';
import './App.css';

function MainPage() {
    const containerRef = useRef(null);
    const [cursorPos, setCursorPos] = useState({ top: 0, left: 0 });
    const [careersText, setCareersText] = useState("Careers");
    
    // Mobile detection
    const [isMobile, setIsMobile] = useState(false);
    
    // Waitlist form state
    const [showWaitlistForm, setShowWaitlistForm] = useState(false);
    const [name, setName] = useState('');
    const [occupation, setOccupation] = useState('');
    const [email, setEmail] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [submitMessage, setSubmitMessage] = useState('');

    // Check for mobile on mount
    useEffect(() => {
        const checkMobile = () => {
            setIsMobile(window.innerWidth <= 768);
        };
        
        checkMobile();
        window.addEventListener('resize', checkMobile);
        
        return () => window.removeEventListener('resize', checkMobile);
    }, []);

    const handleCareersClick = () => {
        setCareersText("Reach out if you're a ML/fullstack engineer");
    };

    const setRandomPosition = () => {
        const container = containerRef.current;
        if (container) {
            const { width, height } = container.getBoundingClientRect();
            const newLeft = Math.random() * (width - 32);
            const newTop = Math.random() * (height - 32);
            setCursorPos({ top: newTop, left: newLeft });
        }
    };

    const handleWaitlistSubmit = async (e) => {
        e.preventDefault();
        setIsSubmitting(true);
        
        try {
            if (!name.trim() || !email || !email.includes('@')) {
                setSubmitMessage('Please fill in all required fields with valid information');
                setIsSubmitting(false);
                return;
            }

            // Send to Formspree
            const response = await fetch('https://formspree.io/f/mjkryqap', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    name: name,
                    occupation: occupation,
                    email: email,
                })
            });

            if (response.ok) {
                setSubmitMessage('You\'ve joined 60+ others on the waitlist!');
                setName('');
                setOccupation('');
                setEmail('');
            } else {
                throw new Error('Form submission failed');
            }
        } catch (error) {
            console.error('Form submission error:', error);
            setSubmitMessage('Something went wrong. Please try again.');
        } finally {
            setIsSubmitting(false);
        }
    };

    useEffect(() => {
        setRandomPosition();
        const interval = setInterval(setRandomPosition, 8000);
        return () => clearInterval(interval);
    }, []);

    return (
        <div className="grid-container" ref={containerRef}>
            <div className="cursor" style={{ top: cursorPos.top, left: cursorPos.left }}></div>
            <div className="left-col">
                <div className="branding">
                    <h1>Carrie.ai</h1>
                    <p>Building in<br /> SF/NYC</p>
                </div>
                <div className="footer-links">
                    <ul>
                        <li onClick={handleCareersClick} style={{ cursor: "pointer" }}>{careersText}</li>

                    </ul>
                </div>
            </div>
            <div className="main-col">
                <p className="intro">
                    <b>We are building the final tool for work.</b>
                    <br />
                    {/* b quietly building the next generation of AI agents—powerful, intuitive, and invisible. */}
                </p>
                <p className="mission">

                We're building an ecosystem of proactive agents that encapsulate the context of your entire workflow and live natively inside your own tools.
                    {/* <br /><br />
                    <strong>Our first agent is live</strong> : an intelligent assistant that transforms how you create presentations. It understands your content, suggests improvements, and automates tedious formatting tasks, letting you focus on what matters most.
                    <br /><br />
                    This is just the beginning of our suite of smart tools designed to supercharge productivity—paving the way for our ultimate vision: an AI-powered OS that redefines human-machine interaction. */}
                </p>
                
                {/* Waitlist Button Section */}
                <div style={{
                    marginTop: '2rem',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'flex-start',
                    textAlign: 'left'
                }}>
                    
                    {/* Waitlist Button/Form */}
                    <div>
                        {!showWaitlistForm ? (
                            <button
                                onClick={() => setShowWaitlistForm(true)}
                                className="lightning-button"
                            >
                                <b>
                                Sign Up for Early Access
                                </b>
                            </button>
                        ) : submitMessage && submitMessage.includes('joined') ? (
                            // Success state
                            <div style={{
                                padding: '0.5rem 0'
                            }}>
                                <p style={{
                                    fontFamily: "'Neue Haas Grotesk Display Pro', sans-serif",
                                    fontWeight: 500,
                                    fontSize: '1rem',
                                    color: '#28a745',
                                    margin: 0,
                                    lineHeight: 1.6
                                }}>
                                    ✓ You've joined 60+ others on the waitlist!
                                </p>
                            </div>
                        ) : (
                            // Form state
                            <div style={{
                                display: 'flex',
                                flexDirection: 'column',
                                gap: '0.5rem',
                                background: '#fafafa',
                                padding: '0.8rem',
                                borderRadius: '4px',
                                border: '1px solid #f0f0f0',
                                minWidth: '240px',
                                maxWidth: '280px'
                            }}>
                                <form onSubmit={handleWaitlistSubmit} style={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    gap: '0.5rem'
                                }}>
                                    <input
                                        type="text"
                                        name="name"
                                        value={name}
                                        onChange={(e) => setName(e.target.value)}
                                        placeholder="Name"
                                        required
                                        autoFocus
                                        style={{
                                            background: '#fff',
                                            border: '1px solid #e5e5e5',
                                            borderRadius: '2px',
                                            padding: '0.5rem',
                                            fontSize: '0.85rem',
                                            fontFamily: "'Neue Haas Grotesk Display Pro', sans-serif",
                                            outline: 'none',
                                            transition: 'border-color 0.2s',
                                            color: '#000'
                                        }}
                                        onFocus={(e) => {
                                            e.target.style.borderColor = '#000';
                                        }}
                                        onBlur={(e) => {
                                            e.target.style.borderColor = '#e5e5e5';
                                        }}
                                    />
                                    <input
                                        type="text"
                                        name="occupation"
                                        value={occupation}
                                        onChange={(e) => setOccupation(e.target.value)}
                                        placeholder="Occupation (optional)"
                                        style={{
                                            background: '#fff',
                                            border: '1px solid #e5e5e5',
                                            borderRadius: '2px',
                                            padding: '0.5rem',
                                            fontSize: '0.85rem',
                                            fontFamily: "'Neue Haas Grotesk Display Pro', sans-serif",
                                            outline: 'none',
                                            transition: 'border-color 0.2s',
                                            color: '#000'
                                        }}
                                        onFocus={(e) => {
                                            e.target.style.borderColor = '#000';
                                        }}
                                        onBlur={(e) => {
                                            e.target.style.borderColor = '#e5e5e5';
                                        }}
                                    />
                                    <input
                                        type="email"
                                        name="email"
                                        value={email}
                                        onChange={(e) => setEmail(e.target.value)}
                                        placeholder="your@email.com"
                                        required
                                        style={{
                                            background: '#fff',
                                            border: '1px solid #e5e5e5',
                                            borderRadius: '2px',
                                            padding: '0.5rem',
                                            fontSize: '0.85rem',
                                            fontFamily: "'Neue Haas Grotesk Display Pro', sans-serif",
                                            outline: 'none',
                                            transition: 'border-color 0.2s',
                                            color: '#000'
                                        }}
                                        onFocus={(e) => {
                                            e.target.style.borderColor = '#000';
                                        }}
                                        onBlur={(e) => {
                                            e.target.style.borderColor = '#e5e5e5';
                                        }}
                                    />
                                     
                                     <div style={{
                                         display: 'flex',
                                         justifyContent: 'flex-start',
                                         marginTop: '0.2rem'
                                     }}>
                                     <button
                                        type="submit"
                                        disabled={isSubmitting}
                                        style={{
                                            background: '#000',
                                            border: 'none',
                                            borderRadius: '2px',
                                            padding: '0.5rem 1rem',
                                            fontSize: '0.85rem',
                                            fontWeight: 500,
                                            cursor: isSubmitting ? 'not-allowed' : 'pointer',
                                            transition: 'all 0.2s',
                                            fontFamily: "'Neue Haas Grotesk Display Pro', sans-serif",
                                            color: '#fff',
                                            letterSpacing: '0.01em'
                                        }}
                                        onMouseEnter={(e) => {
                                            if (!isSubmitting) {
                                                e.target.style.background = '#333';
                                            }
                                        }}
                                        onMouseLeave={(e) => {
                                            if (!isSubmitting) {
                                                e.target.style.background = '#000';
                                            }
                                        }}
                                    >
                                        {isSubmitting ? 'Joining...' : 'Join Waitlist'}
                                    </button>
                                    </div>
                                </form>

                                {submitMessage && !submitMessage.includes('joined') && (
                                    <p style={{
                                        margin: 0,
                                        fontSize: '0.75rem',
                                        color: '#dc3545',
                                        fontFamily: "'Neue Haas Grotesk Display Pro', sans-serif",
                                        fontWeight: 400
                                    }}>
                                        {submitMessage}
                                    </p>
                                )}
                            </div>
                        )}
                    </div>
                </div>

                {/* Demo Link at Bottom */}
                <div style={{
                    marginTop: '3rem',
                    textAlign: 'left'
                }}>
                    <p style={{
                        fontFamily: "'Neue Haas Grotesk Display Pro', sans-serif",
                        fontWeight: 400,
                        fontSize: '0.9rem',
                        margin: 0,
                        color: '#666'
                    }}>
                        <a href="/demo" style={{
                            color: '#666',
                            textDecoration: 'underline',
                            textDecorationColor: '#ccc'
                        }}>Book a Demo for Our First Agent</a>
                    </p>
                </div>
            </div>
        </div>
    );
}

export default MainPage;
